<div>
  <div>
    <label>{{label}}</label>
  </div>
  <ng-content></ng-content>
</div>
